import slick from 'slick-carousel';
import imgLiquid from 'plugs/imgLiquid-min.js';
import 'plugs/jquery.easing.1.3.js';
import 'plugs/svg.js';
import 'plugs/jquery.simplyscroll.min.js';
import 'plugs/jquery.pause.min.js';
import 'plugs/jquery.twzipcode.js';


var $window = $(window);
var winW,winH,footerH,bodyH,scrollTop;


window.onload = function() { 
    
};
$('body').addClass('fade-in');
$(function(){    
    //mobile menu
    var menuicon = $('header .menuicon'),
    navBox = $('header .mmenu'),
    nav = $('header .navBox'),
    $body = $('body,html'),
    $header = $('header');

    menuicon.on('click',function(){
        var $this = $(this);
        if(!$header.hasClass('menu-expanded')){
            $header.addClass('menu-expanded');
            nav.stop().fadeIn();
        }else{
            $header.removeClass('menu-expanded');
            nav.stop().fadeOut(function(){$(this).removeAttr('style');});
        }
        return false;
    });
    
    $('.navBox a').on('click',function(){
        var obj = $(this).attr('href');
        $("html,body").animate({ scrollTop: $(obj).offset().top}, 1000, 'easeOutExpo');
        $header.removeClass('menu-expanded');
        nav.stop().fadeOut(function(){$(this).removeAttr('style');});
        return false;
    });
    //open real    
    var btn_close = $('span.close,a.close'),
        btn_open = $('a[data-popup]'),
        //$body_overlay = $('.popup_bg'),
        $real_overlay = $('.overbg'),
        window_top,
        poval;
    btn_open.on('click',function(event){
        window_top = scrollTop;
        poval = $(this).data('popup');
        $('.modal-content').addClass(poval);
        $body.addClass('modal-open');
        $real_overlay.fadeIn('800');
        $('#modal-content').fadeIn('800');
        return false;
    });
    btn_close.on('click',function(){       
        $real_overlay.fadeOut(500);
        $('.modal-content').fadeOut(500,function(){
          $body.removeClass('modal-open');   
            $('.modal-content').removeClass(poval);
        });
        if(winW < 1024){
          $window.scrollTop(window_top);
        }else{
          $body.removeAttr('data-top');
        }        
    });
    $window.on('resize',function(){
        winW = $window.width();
        winH =  $window.height();
        footerH = $('footer').outerHeight(true);
        bodyH = winH - footerH;  
        //bodyH
        $('main').css('min-height',bodyH);
        if(winW > 991){
            $header.removeClass('menu-expanded');
            $('.navBox').removeAttr('style');
            nav.stop().fadeOut(function(){$(this).removeAttr('style');});
            $body.css({'overflow':''});
        }
        //background-image
        resizeBgcover(winW);
    }).resize();
    $('.mainkv .slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        pauseOnHover:false,
        autoplay:true,
        autoplaySpeed:4000,
        speed:1500,
        arrows: false,
        fade:true,
        dots:true,
    });
    $('.slick-temp1 .slider-txt').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        pauseOnHover:false,
        autoplay:true,
        autoplaySpeed:4000,
        speed:1500,
        arrows: false,
        fade:true,
        dots:true,
        asNavFor: '.slick-temp1 .slider-img',
    });
    $('.slick-temp1 .slider-img').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        pauseOnHover:false,
        autoplay:true,
        autoplaySpeed:4000,
        speed:1500,
        dots:false,
        arrows: false,
        asNavFor: '.slick-temp1 .slider-txt',
    });
    $('.build .slider-img').on('init', function(event, slick){        
        $('.slick-current.slick-active').next().addClass('slide-next');        
        $('.slick-current.slick-active[data-slick-index="2"]').addClass('slide-prev');
    });
    $('.build .slider-img').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        pauseOnHover:false,
        autoplay:true,
        autoplaySpeed:4000,
        speed:0,
        dots:false,
        arrows: false,
        fade:true,
        responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 1
              }
            },
        ]
    });
    $('.build .slider-img').on('afterChange', function(event, slick, currentSlide, nextSlide){
        $('.slick-slide').removeClass('slide-prev slide-next');
        if(currentSlide = 0){
            $('.slick-current.slick-active[data-slick-index="2"]').addClass('slide-prev');
        }
        if(currentSlide = 2){
            $('.slick-current.slick-active[data-slick-index="0"]').addClass('slide-next');
        }
        $('.slick-current.slick-active').prev().addClass('slide-prev');
        $('.slick-current.slick-active').next().addClass('slide-next');
      });
    $('.slick-temp2.v1 .slider-txt').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        pauseOnHover:false,
        autoplay:true,
        autoplaySpeed:4000,
        speed:1500,
        dots:true,
        arrows: false,
        fade:true,
        asNavFor: '.slick-temp2.v1 .slider-img',
    });
    $('.slick-temp2.v1 .slider-img').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        pauseOnHover:false,
        autoplay:true,
        autoplaySpeed:4000,
        speed:1500,
        dots:false,
        arrows: false,
        asNavFor: '.slick-temp2.v1 .slider-txt',
    });
    $('.slick-temp2.v2 .slider-txt').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        pauseOnHover:false,
        autoplay:true,
        autoplaySpeed:4000,
        speed:1500,
        dots:true,
        arrows: false,
        fade:true,
        asNavFor: '.slick-temp2.v2 .slider-img',
    });
    $('.slick-temp2.v2 .slider-img').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        pauseOnHover:false,
        autoplay:true,
        autoplaySpeed:4000,
        speed:1500,
        dots:false,
        arrows: false,
        asNavFor: '.slick-temp2.v2 .slider-txt',
    });
    $('.pattern .imgbox').simplyScroll({
        autoMode: 'loop',
        speed: 1,
        frameRate: 60,
        horizontal: true,
        pauseOnHover: false,
        pauseOnTouch: false
    });
    $("#twzipcode").twzipcode({
        onCountySelect: function() {
            if($(this).val() == ""){
                $('#city_span').html("必填");
                $("#twzipcode").addClass('nonsel');
			}else {
                $('#city_span').html("");
                $("#twzipcode").removeClass('nonsel');
            }
        }
    });
});
function resizeBgcover(winW){
    $('.bgcover[data-lg]').each(function() {
        if(winW > 768){
            var dataImg = $(this).data('lg');
            $(this).css('background-image','url(' + dataImg + ')');
        }else{
            var dataImg = $(this).data('sm');
            $(this).css('background-image','url(' + dataImg + ')');
        }
   });
}

